import { PERMISSIONS } from 'consts'

const foo = [
  {
    title: 'Đơn hàng',
    key: PERMISSIONS.don_hang,
  },

  {
    title: 'Quản lý đặt bàn',
    key: PERMISSIONS.quan_ly_dat_ban,
  },
  {
    title: 'Quản lý nhận xét',
    key: PERMISSIONS.quan_ly_nhan_xet,
  },

  {
    title: 'Phân loại món',
    key: PERMISSIONS.phan_loai_mon,
  },
  {
    title: 'Tạo phân loại món',
    key: PERMISSIONS.tao_phan_loai_mon,
  },
  {
    title: 'Cập nhật phân loại món',
    key: PERMISSIONS.cap_nhat_phan_loai_mon,
  },

  {
    title: 'Quản lý món ăn',
    key: PERMISSIONS.quan_ly_mon_an,
  },
  {
    title: 'Thêm món ăn',
    key: PERMISSIONS.them_mon_an,
  },
  {
    title: 'Cập nhật món ăn',
    key: PERMISSIONS.cap_nhat_mon_an,
  },
  {
    title: 'Quản lý set menu',
    key: PERMISSIONS.quan_ly_setmenu,
  },
  {
    title: 'Quản lý thực đơn',
    key: PERMISSIONS.quan_ly_thuc_don,
  },
  {
    title: 'Thêm thực đơn',
    key: PERMISSIONS.them_thuc_don,
  },
  {
    title: 'Cập nhật thực đơn',
    key: PERMISSIONS.cap_nhat_thuc_don,
  },

  {
    title: 'Topping',
    key: PERMISSIONS.topping,
  },

  {
    title: 'Quản lý thuế',
    key: PERMISSIONS.quan_ly_thue,
  },

  {
    title: 'Quản lý phí dịch vụ',
    key: PERMISSIONS.quan_ly_phi_dich_vu,
  },

  {
    title: 'Quản lý nhân viên',
    key: PERMISSIONS.quan_ly_nhan_vien,
  },

  {
    title: 'Quản lý khách hàng',
    key: PERMISSIONS.quan_ly_khach_hang,
  },
  {
    title: 'Quản lý Block Order',
    key: PERMISSIONS.quan_ly_block_order,
  },
  {
    title: 'Email quản lý',
    key: PERMISSIONS.cai_dat_email_quan_ly,
  },
  {
    title: 'Danh sách invitation',
    key: PERMISSIONS.quan_ly_invitation,
  },

  {
    title: 'Quản lý chi nhánh',
    key: PERMISSIONS.quan_ly_chi_nhanh,
  },

  {
    title: 'Quản lý khu vực',
    key: PERMISSIONS.quan_ly_khu_vuc,
  },

  {
    title: 'Quản lý quốc gia',
    key: PERMISSIONS.quan_ly_quoc_gia,
  },

  {
    title: 'Quản lý bài viết',
    key: PERMISSIONS.quan_ly_bai_viet,
  },
  {
    title: 'Thêm bài viết',
    key: PERMISSIONS.them_bai_viet,
  },
  {
    title: 'Cập nhật bài viết',
    key: PERMISSIONS.cap_nhat_bai_viet,
  },

  {
    title: 'Quản lý quà lưu niệm',
    key: PERMISSIONS.quan_ly_qua_luu_niem,
  },

  {
    title: 'Chương trình khuyến mãi',
    key: PERMISSIONS.chuong_trinh_khuyen_mai,
  },

  {
    title: 'Thêm chương trình khuyến mãi',
    key: PERMISSIONS.them_chuong_trinh_khuyen_mai,
  },

  {
    title: 'Cập nhật chương trình khuyến mãi',
    key: PERMISSIONS.cap_nhat_chuong_trinh_khuyen_mai,
  },

  {
    title: 'Quản lý VOUCHER đã mua',
    key: PERMISSIONS.quan_ly_voucher_da_mua,
  },

  {
    title: 'Phương thức thanh toán',
    key: PERMISSIONS.phuong_thuc_thanh_toan,
  },

  {
    title: 'Quản lý phân quyền',
    key: PERMISSIONS.quan_ly_phan_quyen,
  },
  // {
  //   title: PERMISSIONS.giao_dien_tong_hop_don_hang,
  //   key: PERMISSIONS.giao_dien_tong_hop_don_hang,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_kiem_hang,
  //   key: PERMISSIONS.giao_dien_kiem_hang,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_kiem_hang,
  //       key: PERMISSIONS.tao_kiem_hang,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_kiem_hang,
  //       key: PERMISSIONS.cap_nhat_kiem_hang,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_nhap_hang_vao_vi_tri,
  //   key: PERMISSIONS.giao_dien_nhap_hang_vao_vi_tri,
  //   children: [
  //     {
  //       title: PERMISSIONS.cap_nhat_nhap_hang_vao_vi_tri,
  //       key: PERMISSIONS.cap_nhat_nhap_hang_vao_vi_tri,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_quan_ly_doanh_nghiep,
  //   key: PERMISSIONS.giao_dien_quan_ly_doanh_nghiep,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_doanh_nghiep,
  //       key: PERMISSIONS.tao_doanh_nghiep,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_doanh_nghiep,
  //       key: PERMISSIONS.cap_nhat_doanh_nghiep,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_doanh_nghiep,
  //       key: PERMISSIONS.xoa_doanh_nghiep,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_danh_sach_xuat_hang,
  //   key: PERMISSIONS.giao_dien_danh_sach_xuat_hang,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_danh_sach_xuat_hang,
  //       key: PERMISSIONS.tao_danh_sach_xuat_hang,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_danh_sach_xuat_hang,
  //       key: PERMISSIONS.cap_nhat_danh_sach_xuat_hang,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_dong_goi,
  //   key: PERMISSIONS.giao_dien_dong_goi,
  //   children: [
  //     {
  //       title: PERMISSIONS.cap_nhat_dong_goi,
  //       key: PERMISSIONS.cap_nhat_dong_goi,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_ban_giao_van_chuyen,
  //   key: PERMISSIONS.giao_dien_ban_giao_van_chuyen,
  //   children: [
  //     {
  //       title: PERMISSIONS.cap_nhat_ban_giao_van_chuyen,
  //       key: PERMISSIONS.cap_nhat_ban_giao_van_chuyen,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_da_ban_giao_van_chuyen,
  //   key: PERMISSIONS.giao_dien_da_ban_giao_van_chuyen,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_kho_hang,
  //   key: PERMISSIONS.giao_dien_kho_hang,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_kho_hang,
  //       key: PERMISSIONS.tao_kho_hang,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_kho_hang,
  //       key: PERMISSIONS.cap_nhat_kho_hang,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_kho_hang,
  //       key: PERMISSIONS.xoa_kho_hang,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_o_chua_hang,
  //   key: PERMISSIONS.giao_dien_o_chua_hang,
  //   children: [
  //     {
  //       title: PERMISSIONS.cap_nhat_o_chua_hang,
  //       key: PERMISSIONS.cap_nhat_o_chua_hang,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_thung_dung,
  //   key: PERMISSIONS.giao_dien_thung_dung,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_thung_dung,
  //       key: PERMISSIONS.tao_thung_dung,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_thung_dung,
  //       key: PERMISSIONS.cap_nhat_thung_dung,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_thung_dung,
  //       key: PERMISSIONS.xoa_thung_dung,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_danh_sach_phu_lieu,
  //   key: PERMISSIONS.giao_dien_danh_sach_phu_lieu,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_phu_lieu,
  //       key: PERMISSIONS.tao_phu_lieu,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_phu_lieu,
  //       key: PERMISSIONS.cap_nhat_phu_lieu,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_phu_lieu,
  //       key: PERMISSIONS.xoa_phu_lieu,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_chi_phi_kho,
  //   key: PERMISSIONS.giao_dien_chi_phi_kho,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_chi_phi_kho,
  //       key: PERMISSIONS.tao_chi_phi_kho,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_chi_phi_kho,
  //       key: PERMISSIONS.cap_nhat_chi_phi_kho,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_chi_phi_kho,
  //       key: PERMISSIONS.xoa_chi_phi_kho,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_bang_ke_chi_phi,
  //   key: PERMISSIONS.giao_dien_bang_ke_chi_phi,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_don_vi_van_chuyen,
  //   key: PERMISSIONS.giao_dien_don_vi_van_chuyen,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_don_vi_van_chuyen,
  //       key: PERMISSIONS.tao_don_vi_van_chuyen,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_don_vi_van_chuyen,
  //       key: PERMISSIONS.cap_nhat_don_vi_van_chuyen,
  //     },

  //     {
  //       title: PERMISSIONS.xoa_don_vi_van_chuyen,
  //       key: PERMISSIONS.xoa_don_vi_van_chuyen,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_quan_ly_nhan_vien,
  //   key: PERMISSIONS.giao_dien_quan_ly_nhan_vien,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_nhan_vien,
  //       key: PERMISSIONS.tao_nhan_vien,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_nhan_vien,
  //       key: PERMISSIONS.cap_nhat_nhan_vien,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_nhan_vien,
  //       key: PERMISSIONS.xoa_nhan_vien,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_quan_ly_phan_quyen,
  //   key: PERMISSIONS.giao_dien_quan_ly_phan_quyen,
  //   children: [
  //     {
  //       title: PERMISSIONS.tao_phan_quyen,
  //       key: PERMISSIONS.tao_phan_quyen,
  //     },
  //     {
  //       title: PERMISSIONS.cap_nhat_phan_quyen,
  //       key: PERMISSIONS.cap_nhat_phan_quyen,
  //     },
  //     {
  //       title: PERMISSIONS.xoa_phan_quyen,
  //       key: PERMISSIONS.xoa_phan_quyen,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_lich_su_thao_tac,
  //   key: PERMISSIONS.giao_dien_lich_su_thao_tac,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_quan_ly_xuat_nhap,
  //   key: PERMISSIONS.giao_dien_quan_ly_xuat_nhap,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_quan_ly_thiet_bi_in,
  //   key: PERMISSIONS.giao_dien_quan_ly_thiet_bi_in,
  //   children: [
  //     {
  //       title: PERMISSIONS.cap_nhat_thiet_bi_in,
  //       key: PERMISSIONS.cap_nhat_thiet_bi_in,
  //     },
  //   ],
  // },
  // {
  //   title: PERMISSIONS.giao_dien_bao_cao_ton_kho_tong_hop,
  //   key: PERMISSIONS.giao_dien_bao_cao_ton_kho_tong_hop,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_bao_cao_nhap_kho,
  //   key: PERMISSIONS.giao_dien_bao_cao_nhap_kho,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_bao_cao_xuat_kho,
  //   key: PERMISSIONS.giao_dien_bao_cao_xuat_kho,
  // },
  // {
  //   title: PERMISSIONS.giao_dien_bao_cao_ton_kho_chi_tiet,
  //   key: PERMISSIONS.giao_dien_bao_cao_ton_kho_chi_tiet,
  // },
]
export default foo
